import "core-js/modules/es6.promise";
import "core-js/modules/es6.string.iterator";
import _regeneratorRuntime from "C:/Users/enoch/code/our-meeting-minutes-client/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "C:/Users/enoch/code/our-meeting-minutes-client/node_modules/@babel/runtime/helpers/asyncToGenerator";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.array.find-index";
// Init state
import Vue from "vue";
import { updateMeetingAgendaItems, getAgendaItems } from "src/models/AgendaItem";
import uid from 'quasar/src/utils/uid.js';;

var initState = function initState() {
  return {
    agendaItems: []
  };
}; // State object


var state = initState(); // Mutations

var mutations = {
  setAgendaItems: function setAgendaItems(state, payload) {
    state.agendaItems = payload;
  },
  updateAgendaItemText: function updateAgendaItemText(state, payload) {
    state.agendaItems[payload.index].agenda_item_text = payload.value;
  },
  updateAgendaItemMinutes: function updateAgendaItemMinutes(state, payload) {
    state.agendaItems[payload.index].minutes = payload.value;
  },
  removeAgendaItem: function removeAgendaItem(state, agendaItemId) {
    var index = state.agendaItems.findIndex(function (item) {
      return item.id === agendaItemId;
    });

    if (index !== -1) {
      state.agendaItems.splice(index, 1);
    }
  },
  createAgendaItem: function createAgendaItem(state, payload) {
    var agendaItem = {
      id: uid(),
      agenda_item_text: "",
      minutes: "",
      justAdded: payload.justAdded || false
    };

    if (payload.belowOther) {
      state.agendaItems.splice(payload.index + 1, 0, agendaItem);
    } else {
      state.agendaItems.push(agendaItem);
    }
  },
  setAgendaItemJustAdded: function setAgendaItemJustAdded(state, payload) {
    var item = state.agendaItems.find(function (item) {
      return item.id === payload.agendaItemId;
    });

    if (item) {
      item.justAdded = payload.value;
    }
  },
  setAgendaItemIsRemoving: function setAgendaItemIsRemoving(state, payload) {
    var item = state.agendaItems.find(function (item) {
      return item.id === payload.agendaItemId;
    });

    if (item) {
      Vue.set(item, 'isRemoving', payload.value);
    }
  },
  RESET: function RESET(state) {
    var newState = initState();
    Object.keys(newState).forEach(function (key) {
      state[key] = newState[key];
    });
  }
}; // Actions

var actions = {
  updateAgendaItem: function updateAgendaItem(_ref, payload) {
    var commit = _ref.commit;
    commit("updateAgendaItem", payload);
  },
  setAgendaItems: function setAgendaItems(_ref2, payload) {
    var commit = _ref2.commit;
    commit("setAgendaItems", payload);
  },
  fetchAgendaItems: function fetchAgendaItems(_ref3) {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var commit, dispatch, group, meeting, response, agendaItems;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref3.commit, dispatch = _ref3.dispatch;
              group = _this.getters["Group/group"];
              meeting = _this.getters["Meeting/meeting"];
              _context.next = 5;
              return getAgendaItems(group.id, meeting.id);

            case 5:
              response = _context.sent;
              agendaItems = response.data.agenda_items;

              if (agendaItems) {
                // Set id to rotate stuff arround.
                agendaItems.forEach(function (item) {
                  if (!item.id) item.id = uid();
                });
                commit("setAgendaItems", agendaItems);
              }

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  fetchAgendaItemsByMeetingId: function fetchAgendaItemsByMeetingId(_ref4, meetingId) {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var commit, group, response, agendaItems;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref4.commit;
              group = _this2.getters["Group/group"];
              _context2.next = 4;
              return getAgendaItems(group.id, meetingId);

            case 4:
              response = _context2.sent;
              agendaItems = response.data.agenda_items;

              if (agendaItems) {
                // Set id to rotate stuff arround.
                agendaItems.forEach(function (item) {
                  if (!item.id) item.id = uid();
                });
                commit("setAgendaItems", agendaItems);
              }

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  saveAgendaItems: function saveAgendaItems(_ref5) {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var state, dispatch, group, meeting, updateResponse;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              state = _ref5.state, dispatch = _ref5.dispatch;
              group = _this3.getters["Group/group"];
              meeting = _this3.getters["Meeting/meeting"];
              _context3.prev = 3;
              _context3.next = 6;
              return Promise.all([updateMeetingAgendaItems(group.id, meeting.id, {
                agenda_items: state.agendaItems
              })]);

            case 6:
              updateResponse = _context3.sent;
              return _context3.abrupt("return", updateResponse);

            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3["catch"](3);
              console.error("Error saving agenda items:", _context3.t0);
              throw _context3.t0.response;

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[3, 10]]);
    }))();
  },
  removeAgendaItem: function removeAgendaItem(_ref6, agendaItemId) {
    var commit = _ref6.commit;
    commit("removeAgendaItem", agendaItemId);
  }
}; // Getter functions

var getters = {
  agendaItems: function agendaItems(state) {
    return state.agendaItems;
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};